import { ConnectButton } from '@rainbow-me/rainbowkit'
import Box from '@/components/primitives/Box'
import Button from '@/components/primitives/Button'
import { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignIn } from '@fortawesome/free-solid-svg-icons'
type Props = {}

export const MobileConnectWallet: FC<Props> = () => {
    return (
        <ConnectButton.Custom>
            {({ account, chain, openConnectModal, mounted }) => {
                return (
                    <Box>
                        {(() => {
                            if (!mounted || !account || !chain) {
                                return (
                                    <Button
                                        css={{ justifyContent: 'center', width: '44px', height: '44px' }}
                                        type="button"
                                        onClick={openConnectModal}
                                        size="small"
                                        color="gray3"
                                    >
                                        <FontAwesomeIcon icon={faSignIn} width="16" height="16" />
                                    </Button>
                                )
                            }
                        })()}
                    </Box>
                )
            }}
        </ConnectButton.Custom>
    )
}
